import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6646ddb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#AFB7BD",
    d: "M34.939 25.741h-8.685v8.488c0 3.129-2.513 5.669-5.609 5.669-3.097 0-5.609-2.54-5.609-5.669v-8.488H6.358c-3.097 0-5.609-2.539-5.609-5.668 0-3.13 2.512-5.669 5.609-5.669h8.678v-8.48c0-3.129 2.512-5.669 5.609-5.669 3.096 0 5.609 2.54 5.609 5.669v8.48h8.685c3.097 0 5.609 2.539 5.609 5.669 0 3.129-2.512 5.668-5.609 5.668z"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "new-card__title" }, "افزودن حساب", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: _normalizeClass(['new-card', _ctx.breakpoints.isMobile && 'new-card--mobile'])
  }, _hoisted_3, 2))
}